import React from "react";
import { UiMenu } from "./Dashboard/UiMenu";

export const UiSideBar = () => {
  return (
    <>
      <div className="df-sidebar">
        <div className="df-sb-fixed">
          <UiMenu />
        </div>
      </div>
    </>
  );
};
